import React, {useEffect, useRef, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useForm} from 'react-hook-form';
import Input from '../../global/Input';

import {
    useCreateLandRegisterMutation, useGetGrundbuchTypesQuery,
    useGetLandRegisterQuery,
    useUpdateLandRegisterMutation
} from '../../../redux/rtk/injectedLandregisterApi';
import {useCleanArray} from '../../hooks/useCleanArray';
import {showMessageOnError, showMessageOnSuccess} from '../../global/CustomToast';
import {TabPanel, TabView} from 'primereact/tabview';
import {Mapping, MappingType, resetMappings} from '../../../redux/slices/MappingSlice';
import {useAppDispatch, useAppSelector} from '../../../redux/hooks';
import {PersonMapping} from '../person/PersonMapping';
import {ParcelMapping} from '../parcel/ParcelMapping';
import {checkPermission, saveMappings} from '../../../functions/functionLibrary';
import {useDeleteMappingMutation, useUpdateMappingMutation} from '../../../redux/rtk/injectedMappingApi';
import EditDialogLayout from '../../global/EditDialogLayout';
import FormPrompt from '../../global/FormPrompt';
import {iterateOverKeys} from '../../functions/Global';
import {LandRegisterMapping} from './LandRegisterMapping';
import {Accordion, AccordionTab} from 'primereact/accordion';
import {CommentForm} from '../CommentForm';
import moment from 'moment';
import {useGetBundeslandQuery} from '../../../redux/rtk/injectedIsoBundeslandApi';
import MapOl from '../../geoData/map';
import LayersMapOl from '../../geoData/layer/LayersMapOl';
import BaseLayers from '../../geoData/layer/BaseLayers';
import PoiLayer from '../../geoData/layer/PoiLayer';
import SingleLayer from '../../geoData/layer/SingleLayer';
import geoSettings from '../../../config/geoSettings';
import {LandRegister, moveComments} from '../../functions/GlobalData';
import StatusLight from '../../global/StatusLight';
import UnderConstruction from '../../../views/pages/UnderConstruction';
import CautionSign from '../../global/CautionSign';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faDatabase, faInfoCircle, faList, faMapLocation, faProjectDiagram} from '@fortawesome/free-solid-svg-icons';
import {LandRegisterInventory} from './LandRegisterInventory';
import {LandRegisterDepartment} from './LandRegisterDepartment';
import {ProcessOverview} from '../process/ProcessOverview';
import {UtilisationOverview} from '../../projectMasterData/utilisation/UtilisationOverview';
import {MeasureOverview} from '../../projectMasterData/measure/MeasureOverview';
import {permissions} from '../../../config/permissions';
import {Button} from "primereact/button";

type Props = {
    id: string,
    projectId: string,
    data: any,
    setIsDirty: (isDirty: boolean) => void
    // eslint-disable-next-line react/no-unused-prop-types
    onFinished: (success: any) => void,
    createNew?: boolean,
    duplicateNew?: boolean,
}
export const LandRegisterEditForm = (props: Props): JSX.Element => {
    const {t} = useTranslation(['common', 'stammdaten']);

    const mappings: Mapping[] = useAppSelector((state: any) => state.mappingData.mappings);
    const dispatch = useAppDispatch();
    const [updateMapping] = useUpdateMappingMutation();
    const [deleteMapping] = useDeleteMappingMutation();

    const [create, resultCreate] = useCreateLandRegisterMutation();
    const [update, resultUpdate] = useUpdateLandRegisterMutation();

    const [data, setData] = useState<any>();
    const [height, setHeight] = useState<number>(0);
    const [types, setTypes] = useState<any[]>([]);
    const [selectedType, setSelectedType] = useState<any>(undefined);

    const [mappingChanged, setMappingChanged] = useState<boolean>(false);
    const [createNew, setCreateNew] = useState<boolean>(false);
    const [duplicateNew, setDuplicateNew] = useState<boolean>(false);
    const [showLandRegisterMapping, setShowLandRegisterMapping] = useState<boolean>(false);

    const divRef: any = useRef(null);

    const typesFetch = useGetGrundbuchTypesQuery({});

    const {data: bundeslandQuery = [], isLoading} = useGetBundeslandQuery();

    const countryIsoList = [{
        label: <div className={'flex'}><img className={'mr-1'}
                                            src={'/images/wappen/deutschland.svg'}
                                            width={25}
                                            height={25}/>
            <div className={'my-auto'}>Deutschland</div>
        </div>, value: 'Deutschland'
    }];

    // eslint-disable-next-line camelcase
    const isCleaned = useCleanArray(data, {
        grundbuch_id: props.data ? props.data.grundbuch_id : undefined,
        project_id: props.projectId !== '' ? props.projectId : null
    }, true);

    const defaultValues: LandRegister = {
        'active_id': props.data ? props.data.active_id : '',
        'grundbuch_id': props.data ? props.data.grundbuch_id : '',
        'b_land_iso': props.data ? props.data.b_land_iso : '',
        'b_land_name': props.data ? props.data.b_land_name : '',
        'land_iso': props.data ? props.data.land_iso : '',
        'land_name': props.data ? props.data.land_name : '',
        'amtsgericht': props.data ? props.data.amtsgericht : '',
        'band': props.data ? props.data.band : '',
        'blatt': props.data ? props.data.blatt : '',
        'anteile': props.data ? props.data.anteile : '',
        'bezirk': props.data ? props.data.bezirk : '',
        'gbbz': props.data ? props.data.gbbz : 0,
        'buchungsblattkenn': props.data ? props.data.buchungsblattkenn : '',
        'kommentar': props.data ? props.data.kommentar : [],
        'kommentare': props.data ? props.data.kommentare : [],
        'person': props.data ? props.data.person : [],
        'flurstueck': props.data ? props.data.flurstueck : [],
        'expandableElement': props.data ? props.data.expandableElement : undefined,
        'type_id': props.data ? props.data.type_id : 0,
        'subtype_id': props.data ? props.data.subtype_id : 0,
        'status_id': props.data ? props.data.status_id : 0,
        'letzte_aenderung_zeitstempel': props.data && props.data.letzte_aenderung_zeitstempel != null ? new Date(props.data.letzte_aenderung_zeitstempel) : null,
        'abruf_zeitstempel': props.data && props.data.abruf_zeitstempel != null ? new Date(props.data.abruf_zeitstempel) : null,
        'pruefung_zeitstempel': props.data && props.data.pruefung_zeitstempel != null ? new Date(props.data.pruefung_zeitstempel) : null,
    };

    const {
        control,
        formState: {errors, isDirty},
        handleSubmit,
        getValues,
        setValue,
        reset,
        watch
    } = useForm({defaultValues});

    const kommentare = watch('kommentare');
    const typeId = watch('type_id');
    const statusId = watch('status_id');

    useEffect(() => {
        if (props.createNew) {
            setCreateNew(props.createNew);
        }
        if (props.duplicateNew) {
            setDuplicateNew(props.duplicateNew);
        }
    }, [props.createNew, props.duplicateNew]);

    useEffect(() => {
        console.log(typeId);
        switch (typeId) {
            case 1:
                setShowLandRegisterMapping(true);
                break;
            default:
                setShowLandRegisterMapping(false);
                break;
        }
    }, [typeId]);

    useEffect(() => {
        if (createNew) {
            setCreateNew(false);
            setData(undefined);
            reset({
                'grundbuch_id': '',
                'b_land_iso': '',
                'b_land_name': '',
                'land_iso': '',
                'land_name': '',
                'amtsgericht': '',
                'blatt': '',
                'bvnr': 0,
                'anteile': '',
                'bezirk': '',
                'gbbz': 0,
                'buchungsblattkenn': '',
                'kommentar': [],
                'kommentare': [],
                'person': [],
                'flurstueck': [],
                'expandableElement': undefined,
                'type_id': 0,
                'subtype_id': 0,
                'status_id': 0,
                'letzte_aenderung_zeitstempel': null,
                'abruf_zeitstempel': null,
                'pruefung_zeitstempel': null,
            });
            showMessageOnSuccess('', t('globalData:toasts.createNewMessage'));
        }
    }, [createNew]);

    useEffect(() => {
        if (duplicateNew) {
            setDuplicateNew(false);
            reset(undefined, {keepValues: true});
            showMessageOnSuccess('', t('globalData:toasts.duplicateNewMessage'));
        }
    }, [duplicateNew]);

    // <--- Accordion Headlines

    useEffect(() => {
        dispatch(resetMappings());

    }, []);

    useEffect(() => {
        props.setIsDirty(isDirty || mappingChanged);
    }, [isDirty, mappingChanged]);

    useEffect(() => {
        if (typesFetch && typesFetch.data) {
            const temp = typesFetch.data.map((item: any) => {
                return {value: item.id, label: item.name, subtypes: item.subtypes};
            });
            setTypes(temp);

            if (props.data && props.data.type_id) {
                setSelectedType(temp.find((item: any) => item.value === props.data.type_id));
            }
        }
    }, [typesFetch]);

    useEffect(() => {
        if (typeof data !== 'undefined') {
            if (props.data) {
                update(isCleaned).then(async (result: any) => {
                    if (!result.error) {
                        if (await saveMappings('grundbuch_id', props.data.grundbuch_id, mappings, updateMapping, deleteMapping)) {
                            showMessageOnSuccess(t('globalData:global.landRegisterUpdated'), '');
                            props.onFinished(isCleaned);
                            moveComments(getValues, setValue);
                            reset(undefined, {keepValues: true});
                            setMappingChanged(false);
                        }
                    }
                });
            } else {
                create(isCleaned).then(async (result: any) => {
                    if (!result.error) {
                        if (await saveMappings('grundbuch_id', result.data.grundbuch_id, mappings, updateMapping, deleteMapping)) {
                            showMessageOnSuccess(t('globalData:global.landRegisterCreated'), '');
                            props.onFinished(isCleaned);
                            moveComments(getValues, setValue);
                            reset(undefined, {keepValues: true});
                            setMappingChanged(false);
                        }
                    }
                });
            }
        }
    }, [data]);

    useEffect(() => {
        if (divRef.current) {
            setHeight(divRef.current.parentElement.clientHeight - 150);
        }
    }, [divRef.current]);

    const saveData = (data: any, event: any) => {
        console.log(event);
        data = iterateOverKeys(data);
        // console.log(data)
        setData(data);
    };

    const getFormErrorMessage = (name: string) => {
        if (name.indexOf('.') >= 0) {
            const split = name.split('.');

            if (split.length === 3) {
                // @ts-ignore
                if (errors[split[0]] && errors[split[0]][split[1]] && errors[split[0]][split[1]][split[2]]) {
                    // @ts-ignore
                    const text = errors[split[0]][split[1]][split[2]].message;

                    showMessageOnError('', text);
                    return <small className="p-error custom">{text}</small>;
                }
            }
        } else {
            // @ts-ignore
            if (errors[name]) {
                // @ts-ignore
                const text = errors[name].message;

                showMessageOnError('', text);

                return <small className="p-error custom">{text}</small>;
            }
        }
        return undefined;
    };

    // Accordion Headlines --->

    const getCommentAccordionHeadline = () => {
        let right = '';

        if (kommentare && kommentare.length > 0) {
            right = moment(kommentare[0].zeitstempel).format(t('datetimeformat')) + ': ' +
                kommentare[0].kommentar;
        }

        return (<div className={'grid grid-nogutter'}>
            <div
                className={'col'}>{t('comments') + (kommentare && kommentare.length > 0 ? ` (${kommentare.length})` : '')}</div>
            <div className={'col-auto text-right accordion-addition'}>{right}</div>
        </div>);
    };

    const getStatus = () => {
        return (
            <StatusLight id={'statuslight-landregistereditform'} value={statusId} info={'Testinfo'} light={false}
                         horizontal={false}
                         caution={false}/>);
    };

    return (<div className={'relative h-full'}>
        <form ref={divRef} id={props.id} onSubmit={handleSubmit(saveData)} className={'h-full'}>
            <FormPrompt hasUnsavedChanges={isDirty || mappingChanged}/>
            <EditDialogLayout left={<>
                <div className={'h-full'}>
                    <div className={'grid'}>
                        <div className={'col-6 grid grid-nogutter'}>
                            <div className={'col-12 md:col-6'}>
                                {getStatus()}
                            </div>
                            <div className={'col-12 md:col-6'}>

                            </div>
                        </div>
                        <div className={'col-12 md:col-6'}>
                            <Input
                                edit={false} label={t('globalData:landRegister.id')} name={'grundbuch_id'}
                                value={props.data ? props.data.grundbuch_id : undefined}
                            />
                        </div>
                        <div className={'col-12 md:col-6'}>
                            <Input
                                edit={false} label={t('globalData:parcels.countryIso')} name={'land_name'}
                                value={props.data ? props.data.land_name : undefined}
                                type={'dropdown'}
                                dropdownOptions={countryIsoList}
                                validationControl={control} validationErrorMessage={getFormErrorMessage}
                                validationRules={{
                                    required: false,
                                }}
                            />
                        </div>
                        <div className={'col-12 md:col-6'}><Input
                            edit={false} label={t('globalData:parcels.stateIso')} name={'b_land_iso'}
                            type={'dropdown'}
                            dropdownOptions={bundeslandQuery.map((item: any) => {
                                return {
                                    value: item.id, label: <div className={'flex'}><img className={'mr-1'}
                                                                                        src={`/images/wappen/${item.id}.svg`}
                                                                                        width={25}
                                                                                        height={25}/>
                                        <div className={'my-auto'}>{item.name}</div>
                                    </div>,
                                };
                            })}
                            validationControl={control} validationErrorMessage={getFormErrorMessage}
                            validationRules={{
                                required: false,
                            }}
                        /></div>
                    </div>
                    <hr/>
                    <div className={'grid'}>
                        <div className={'col-12 md:col-6'}>
                            <Input
                                edit={checkPermission(permissions.editLandregister)}
                                label={t('globalData:landRegister.amtsgericht')}
                                name={'amtsgericht'}
                                validationControl={control} validationErrorMessage={getFormErrorMessage}
                                validationRules={{
                                    // required: false,
                                    required: t('globalData:landRegister.amtsgericht') + ' ' + t('input:required')
                                }}
                            />
                        </div>
                        <div className={'col-12 md:col-6'}>
                            <Input
                                edit={checkPermission(permissions.editLandregister)}
                                label={t('globalData:landRegister.bezirk')}
                                name={'bezirk'}
                                validationControl={control} validationErrorMessage={getFormErrorMessage}
                                validationRules={{
                                    // required: false,
                                    required: t('globalData:landRegister.bezirk') + ' ' + t('input:required')
                                }}
                            />
                        </div>
                        <div className={'col-12 md:col-6'}>
                            <Input
                                edit={checkPermission(permissions.editLandregister)}
                                label={t('globalData:landRegister.blatt')}
                                name={'blatt'}
                                validationControl={control} validationErrorMessage={getFormErrorMessage}
                                validationRules={{
                                    // required: false,
                                    required: t('globalData:landRegister.blatt') + ' ' + t('input:required')
                                }}
                            />
                        </div>
                        <div className={'col-12 md:col-6'}>
                            <Input
                                edit={checkPermission(permissions.editLandregister)}
                                label={t('globalData:landRegister.band')}
                                name={'band'}
                                validationControl={control} validationErrorMessage={getFormErrorMessage}
                                validationRules={{
                                    required: false,
                                    // required: true
                                }}
                            />
                        </div>
                        <div className={'col-12 md:col-6'}>
                            <Input edit={checkPermission(permissions.editLandregister)} name={'type_id'}
                                   type={'dropdown'}
                                   label={t('globalData:landRegister.type')}
                                   dropdownOptions={types}
                                   validationControl={control} validationErrorMessage={getFormErrorMessage}
                                   validationRules={{
                                       // required: false,
                                       required: t('globalData:landRegister.type') + ' ' + t('input:required')
                                   }}
                                   onChange={(e) => {
                                       setSelectedType(types.find((item: any) => item.value === e.value));
                                   }}/>
                        </div>
                        {/* <div className={'col-12 md:col-6'}>*/}
                        {/*    <Input edit={checkPermission(permissions.editLandregister)} name={'subtype_id'} type={'dropdown'}*/}
                        {/*           label={t('globalData:landRegister.subtype')}*/}
                        {/*           dropdownOptions={selectedType && selectedType.subtypes && selectedType.subtypes[0] != null ? selectedType.subtypes.map((item: any) => {*/}
                        {/*               return {value: item.id, label: item.name};*/}
                        {/*           }) : []}*/}
                        {/*           validationControl={control} validationErrorMessage={getFormErrorMessage}*/}
                        {/*           validationRules={{required: false}}*/}
                        {/*           disabled={selectedType == null || selectedType.subtypes == null || selectedType.subtypes[0] == null}/>*/}
                        {/* </div>*/}

                        <div className={'col-12 md:col-6'}>
                            <Input
                                edit={checkPermission(permissions.editLandregister)}
                                label={t('globalData:landRegister.letzte_aenderung_zeitstempel')}
                                name={'letzte_aenderung_zeitstempel'}
                                type={'date'}
                                showTime={false}
                                validationControl={control}
                                validationErrorMessage={getFormErrorMessage}
                                validationRules={{required: false}}
                            />
                        </div>
                        <div className={'col-12 md:col-6'}>
                            <Input
                                edit={checkPermission(permissions.editLandregister)}
                                label={t('globalData:landRegister.abruf_zeitstempel')}
                                name={'abruf_zeitstempel'}
                                type={'date'}
                                showTime={false}
                                validationControl={control}
                                validationErrorMessage={getFormErrorMessage}
                                validationRules={{required: false}}
                            />
                        </div>
                        <div className={'col-12 md:col-6'}>
                            <Input
                                edit={checkPermission(permissions.editLandregister)}
                                label={t('globalData:landRegister.pruefung_zeitstempel')}
                                name={'pruefung_zeitstempel'}
                                type={'date'}
                                showTime={false}
                                validationControl={control}
                                validationErrorMessage={getFormErrorMessage}
                                validationRules={{required: false}}
                            /></div>
                        <div className={'col'}>
                            <Button disabled={true} className={'mt-3'}
                                    label={t('globalData:buttons.propertyResearch')}/>
                        </div>
                    </div>
                    <br/>
                    <Accordion>
                        <AccordionTab
                            header={getCommentAccordionHeadline()}>
                            <CommentForm projectId={props.projectId} t={t} type={'grundbuch'}
                                         getFormErrorMessage={getFormErrorMessage}
                                         form={{
                                             control,
                                             formState: {errors},
                                             handleSubmit,
                                             setValue,
                                             getValues,
                                             watch
                                         }} edit={checkPermission(permissions.editLandregister)}
                                         kommentare={kommentare}/>
                        </AccordionTab>
                    </Accordion>
                    <br/>
                    <Accordion>
                        <AccordionTab header={t('documents')}>
                            <UnderConstruction/>
                        </AccordionTab>
                    </Accordion>
                </div>
            </>} right={
                <TabView activeIndex={0} renderActiveOnly={false}>
                    <TabPanel header={<div><FontAwesomeIcon className="sidebar-icon mr-2"
                                                            icon={faInfoCircle}/>{t('tabs.grundbuchInfo')}</div>}>
                        <div className={'grid p-3'}>
                            <div className={'col-12'}>
                                <LandRegisterInventory projectId={props.projectId}
                                                       grundbuchId={props.data ? props.data.grundbuch_id : ''}
                                                       isDirty={isDirty || mappingChanged}
                                                       skip={!props.data}
                                                       onChange={() => {
                                                           setMappingChanged(true);
                                                       }}/>
                                <br/>
                                <LandRegisterDepartment projectId={props.projectId}
                                                        grundbuchId={props.data ? props.data.grundbuch_id : ''}
                                                        isDirty={isDirty || mappingChanged}
                                                        skip={!props.data}
                                                        onChange={() => {
                                                            setMappingChanged(true);
                                                        }}/>
                            </div>
                        </div>
                    </TabPanel>
                    <TabPanel header={<div><FontAwesomeIcon className="sidebar-icon mr-2"
                                                            icon={faMapLocation}/>{t('tabs.geoMap')}</div>}>
                    </TabPanel>
                    <TabPanel header={<div><FontAwesomeIcon className="sidebar-icon mr-2"
                                                            icon={faDatabase}/>{t('tabs.relationshipProjectMasterData')}
                    </div>}>
                        <br/>
                        {checkPermission(permissions.seeMeasures) && <><Accordion activeIndex={0}>
                            <AccordionTab header={t('projectMasterData:measures.plural')}>
                                <MeasureOverview
                                    projectId={props.projectId}
                                    mapping={data ? {grundbuch_id: data.grundbuch_id} : {}}
                                    editable={false}
                                    expandable={false}
                                    hideGlobalFilter={false}
                                    showColumnFilters={true}
                                    hideButtons={true}
                                    skeletonCount={1}
                                    showHeader={false}
                                />
                            </AccordionTab>
                        </Accordion>
                            <br/></>}
                        {checkPermission(permissions.seeUtilisation) && <><Accordion activeIndex={0}>
                            <AccordionTab header={t('projectMasterData:utilisation.plural')}>
                                <UtilisationOverview
                                    projectId={props.projectId}
                                    mapping={data ? {grundbuch_id: data.grundbuch_id} : {}}
                                    editable={false}
                                    expandable={false}
                                    hideGlobalFilter={false}
                                    showColumnFilters={true}
                                    hideButtons={true}
                                    skeletonCount={1}
                                    showHeader={false}
                                />
                            </AccordionTab>
                        </Accordion></>}
                    </TabPanel>
                    <TabPanel header={<div><FontAwesomeIcon className="sidebar-icon mr-2"
                                                            icon={faProjectDiagram}/>{t('tabs.relationshipProjectProcessing')}
                    </div>}>
                        <br/>
                        {checkPermission(permissions.seeProcess) && <><Accordion activeIndex={0}>
                            <AccordionTab header={t('globalData:process.plural')}>
                                <ProcessOverview
                                    showPersons={false}
                                    showParcels={false}
                                    showLandRegisters={false}
                                    mapping={props.data ? {grundbuch_id: props.data.grundbuch_id} : {}}
                                    projectId={props.projectId}
                                    editable={false}
                                    expandable={false}
                                    hideGlobalFilter={false}
                                    showColumnFilters={true}
                                    skeletonCount={1}
                                    showHeader={false}
                                />
                            </AccordionTab>
                        </Accordion>
                            <br/></>}
                        {checkPermission(permissions.seePersons) && <><Accordion activeIndex={0}>
                            <AccordionTab header={t('globalData:global.personen')}>
                                <PersonMapping projectId={props.projectId}
                                               mappingId={props.data ? props.data.grundbuch_id : ''}
                                               mappingType={MappingType.personLandRegister}
                                    // dataIds={props.data && props.data.person ? props.data.person : []}
                                    //            scrollHeight={`${height / 2 - 130}px`}
                                               showHeader={false} skip={!props.data}
                                               onChange={() => {
                                                   setMappingChanged(true);
                                               }} isDirty={isDirty || mappingChanged}/>
                            </AccordionTab>
                        </Accordion>
                            <br/></>}
                        {checkPermission(permissions.seeParcels) && <><Accordion activeIndex={0}>
                            <AccordionTab header={t('globalData:global.flurstuecke')}>
                                <ParcelMapping projectId={props.projectId}
                                               mappingId={props.data ? props.data.grundbuch_id : ''}
                                               mappingType={MappingType.landRegisterParcel}
                                    // dataIds={props.data && props.data.flurstueck ? props.data.flurstueck : []}
                                    //            scrollHeight={`${height / 2 - 130}px`}
                                               showHeader={false} skip={!props.data}
                                               onChange={() => {
                                                   setMappingChanged(true);
                                               }}
                                               isDirty={isDirty || mappingChanged}/>
                            </AccordionTab>
                        </Accordion>
                            <br/></>}
                        <Accordion>
                            <AccordionTab disabled={true} header={t('globalData:global.ecoAccounts')}>
                                <UnderConstruction/>
                            </AccordionTab>
                        </Accordion>
                        <br/>
                        <Accordion>
                            <AccordionTab disabled={true} header={t('globalData:global.research')}>
                                <UnderConstruction/>
                            </AccordionTab>
                        </Accordion>
                        <br/>
                        <Accordion>
                            <AccordionTab disabled={true} header={t('correspondence:plural')}>
                                <UnderConstruction/>
                            </AccordionTab>
                        </Accordion>
                        <br/>
                        <Accordion>
                            <AccordionTab disabled={true} header={t('contract:pluralShort')}>
                                <UnderConstruction/>
                            </AccordionTab>
                        </Accordion>
                        <br/>
                        <Accordion>
                            <AccordionTab disabled={true} header={t('globalData:global.legalProceedings')}>
                                <UnderConstruction/>
                            </AccordionTab>
                        </Accordion>
                        <br/>
                        <Accordion>
                            <AccordionTab disabled={true} header={t('payment:plural')}>
                                <UnderConstruction/>
                            </AccordionTab>
                        </Accordion>
                        <br/>
                        <Accordion>
                            <AccordionTab disabled={true} header={t('invoice:plural')}>
                                <UnderConstruction/>
                            </AccordionTab>
                        </Accordion>
                    </TabPanel>
                    <TabPanel disabled={true} header={<div><FontAwesomeIcon className="sidebar-icon mr-2"
                                                                            icon={faList}/>{t('tabs.relationshipProjectManagement')}
                    </div>}></TabPanel>
                </TabView>
            }/>
        </form>
    </div>);
};
